if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        const initialMedia = this.elements.viewer.querySelector(
          '.is-active[data-media-id]'
        );

        if (initialMedia) {
          this.filterColorMedia(initialMedia.dataset.mediaId);
        }

        // 共通のPC表示：写真1枚＋クリック・左右矢印で切り替え
        {
          const firstSlide = this.elements.viewer.querySelector(
            'li[data-media-id]'
          );

          if (
            firstSlide &&
            !this.elements.viewer.querySelector(
              'li[data-media-id].is-active'
            )
          ) {
            firstSlide.classList.add('is-active');
            this.filterColorMedia(firstSlide.dataset.mediaId);
          }

          this.setAttribute('data-single-photo', '');

          if (!document.getElementById('single-photo-desktop-style')) {
            const style = document.createElement('style');
            style.id = 'single-photo-desktop-style';
            style.textContent = `
              @media (min-width: 990px) {
                media-gallery[data-single-photo]
                [id^="Slider-Gallery-"] {
                  display: block !important;
                }

                media-gallery[data-single-photo]
                [id^="Slider-Gallery-"] > li[data-media-id] {
                  display: none !important;
                }

                media-gallery[data-single-photo]
                [id^="Slider-Gallery-"] > li[data-media-id].is-active {
                  display: block !important;
                  width: 100% !important;
                  max-width: 100% !important;
                  margin: 0 !important;
                }

                media-gallery[data-single-photo]
                [id^="GalleryThumbnails-"],
                media-gallery[data-single-photo]
                [id^="GalleryViewer-"] > .slider-buttons {
                  display: none !important;
                }

                media-gallery[data-single-photo]
                .product__modal-opener--image .product__media-toggle {
                  cursor: pointer;
                }
              }
            `;
            document.head.appendChild(style);
          }

          // シンプルな左右の矢印
          const arrowStyle = document.createElement('style');
          arrowStyle.textContent = `
            media-gallery[data-single-photo] .single-photo-arrow {
              display: none;
            }

            @media (min-width: 990px) {
              media-gallery[data-single-photo]
              [id^="GalleryViewer-"] {
                position: relative;
              }

              media-gallery[data-single-photo] .single-photo-arrow {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                z-index: 5;
                width: 44px;
                height: 44px;
                padding: 0;
                border: 0;
                background: transparent;
                color: #222;
                font-family: Arial, sans-serif;
                font-size: 36px;
                line-height: 1;
                cursor: pointer;
              }

              media-gallery[data-single-photo]
              .single-photo-arrow--prev {
                left: 8px;
              }

              media-gallery[data-single-photo]
              .single-photo-arrow--next {
                right: 8px;
              }

              media-gallery[data-single-photo]
              .single-photo-arrow:focus-visible {
                outline: 2px solid currentColor;
                outline-offset: -4px;
              }
            }
          `;
          this.appendChild(arrowStyle);

          [-1, 1].forEach((direction) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className =
              'single-photo-arrow single-photo-arrow--' +
              (direction === -1 ? 'prev' : 'next');
           const arrow = document.createElement('span');
arrow.setAttribute('aria-hidden', 'true');
arrow.style.cssText = `
  display: block;
  width: 10px;
  height: 10px;
  border-top: 1px solid currentColor;
  border-right: 1px solid currentColor;
  transform: rotate(${direction === -1 ? '-135deg' : '45deg'});
`;
button.appendChild(arrow);

            button.setAttribute(
              'aria-label',
              direction === -1 ? '前の写真' : '次の写真'
            );

            button.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();

              const order = [
                ...(this.currentColorMediaIds || []),
                '31232848298173',
              ];

              const photos = Array.from(
                this.elements.viewer.querySelectorAll(
                  'li[data-media-id]'
                )
              ).filter((item) => {
                if (!this.currentColorMediaIds) return true;
                return order.includes(
                  item.dataset.mediaId.split('-').pop()
                );
              });

              photos.sort(
                (a, b) =>
                  order.indexOf(
                    a.dataset.mediaId.split('-').pop()
                  ) -
                  order.indexOf(
                    b.dataset.mediaId.split('-').pop()
                  )
              );

              if (photos.length < 2) return;

              const current = photos.findIndex((item) =>
                item.classList.contains('is-active')
              );

              const target =
                photos[
                  (current + direction + photos.length) %
                    photos.length
                ];

              this.setActiveMedia(target.dataset.mediaId, false);
            });

            this.elements.viewer.appendChild(button);
          });

          this.elements.viewer.addEventListener(
            'click',
            (event) => {
              if (
                !window.matchMedia('(min-width: 990px)').matches
              ) {
                return;
              }

              const photo = event.target.closest(
                'li[data-media-id].is-active'
              );

              if (!photo || !photo.querySelector('img')) return;

              if (
                photo.querySelector('video, iframe, model-viewer')
              ) {
                return;
              }

              // 写真クリックによる拡大を止める
              event.preventDefault();
              event.stopImmediatePropagation();

              const items = Array.from(
                this.elements.viewer.querySelectorAll(
                  'li[data-media-id]'
                )
              ).filter((item) => {
                if (!this.currentColorMediaIds) return true;

                const id = item.dataset.mediaId.split('-').pop();

                return (
                  this.currentColorMediaIds.includes(id) ||
                  id === '31232848298173'
                );
              });

              if (items.length < 2) return;

              const photoOrder = [
                ...(this.currentColorMediaIds || []),
                '31232848298173',
              ];

              items.sort((a, b) => {
                const aId = a.dataset.mediaId.split('-').pop();
                const bId = b.dataset.mediaId.split('-').pop();

                return (
                  photoOrder.indexOf(aId) -
                  photoOrder.indexOf(bId)
                );
              });

              const currentIndex = items.findIndex((item) =>
                item.classList.contains('is-active')
              );

              const next =
                items[(currentIndex + 1) % items.length];

              this.setActiveMedia(next.dataset.mediaId, false);
            },
            true
          );
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');
            if (!button) return;

            button.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false
              )
            );
          });

        if (
          this.dataset.desktopLayout?.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement?.dataset.mediaId;

        if (!mediaId || !this.elements.thumbnails) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');
        this.filterColorMedia(activeMedia.dataset.mediaId);

        if (prepend) {
          if (activeMedia.parentElement.firstElementChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${activeMedia.dataset.mediaId}"]`
              );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstElementChild !==
                activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }

          if (this.elements.thumbnails?.slider) {
            this.elements.thumbnails.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${activeMedia.dataset.mediaId}"]`
          );

        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      filterColorMedia(mediaId) {
        if (this.dataset.productId !== '8308193427645') return;

        const navyIds = [
          '31394509488317',
          '31394509521085',
        ];

        const blackIds = [
          '47445511209149',
          '47445511176381',
        ];

        const commonId = '31232848298173';
        const selectedId = String(mediaId).split('-').pop();

        if (navyIds.includes(selectedId)) {
          this.currentColorMediaIds = navyIds;
        } else if (blackIds.includes(selectedId)) {
          this.currentColorMediaIds = blackIds;
        }

        if (!this.currentColorMediaIds) return;

        if (blackIds.includes(selectedId)) {
          const list = this.elements.viewer.querySelector('ul');
          const otherBlackId = blackIds.find(
            (id) => id !== selectedId
          );

          const commonMedia = list?.querySelector(
            `li[data-media-id$="-${commonId}"]`
          );

          const otherBlackMedia = list?.querySelector(
            `li[data-media-id$="-${otherBlackId}"]`
          );

          if (commonMedia && otherBlackMedia) {
            list.append(otherBlackMedia, commonMedia);
          }
        }

        const visibleIds = new Set([
          ...this.currentColorMediaIds,
          commonId,
        ]);

        this.elements.viewer
          .querySelectorAll('li[data-media-id]')
          .forEach((item) => {
            const id = item.dataset.mediaId.split('-').pop();

            if (visibleIds.has(id)) {
              item.style.removeProperty('display');
            } else {
              item.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });

        this.elements.thumbnails
          ?.querySelectorAll('[data-target]')
          .forEach((item) => {
            const id = item.dataset.target.split('-').pop();

            if (visibleIds.has(id)) {
              item.style.removeProperty('display');
            } else {
              item.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });

        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }

        if (this.elements.thumbnails?.slider) {
          this.elements.thumbnails.resetPages();
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        thumbnail
          .querySelector('button')
          ?.setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          return;
        }

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}
